import { useTranslation } from "react-i18next";
import { BotMainInfo } from "./BotMainInfo";
import { StartMessageInput } from "./StartMessageInput";
import { ChatbotAssistantSelection } from "./ChatbotAssistantSelection";
import { DialogHistorySwitcher } from "./DialogHistorySwitcher";
import { ChatbotValue } from "../../../../../../services/api/instances/botApi/types";
import { TValueForService } from "../../../../../../services/api/instances/storageApi/types/service_types";
import { NormalizedStorageObject } from "../../../../../../services/api/instances/storageApi/types/object_types";
import styles from "./styles.module.css";
import { AssistantValue } from "../../../../../../services/api/instances/assistantsApi/types";

interface Props {
  assistants: NormalizedStorageObject<AssistantValue>[];
  bot: NormalizedStorageObject<ChatbotValue> | null;
  saveChatbotValue: (
    value: TValueForService<"ai_agents_telegram_bots">,
  ) => void;
  handleChangeApi: (token: string) => void;
}

export const ChatbotMainInfo = (props: Props) => {
  const { t } = useTranslation();

  return (
    <div className={styles["block-container"]}>
      <BotMainInfo
        title={t("chatbot.main_title")}
        name={props.bot?.value?.tg_bot_object?.bot_name as string}
        api={props.bot?.value?.tg_bot_object?.bot_api as string}
        handleChangeApi={props.handleChangeApi}
        label={t("chatbot.change_bot_button")}
        bot={props.bot}
      />
      <StartMessageInput
        inputPlaceholder={t(
          "chatbotPageRoute.input_welcome_message_placeholder",
        )}
        selectedObject={props.bot}
        saveChatbotValue={props.saveChatbotValue}
      />
      <ChatbotAssistantSelection
        assistants={props.assistants}
        selectedObject={props.bot}
        saveChatbotValue={props.saveChatbotValue}
      />
      <DialogHistorySwitcher
        saveChatbotValue={props.saveChatbotValue}
        label={t("chatbot.record_dialog_toggle")}
      />
    </div>
  );
};
